import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const SmellTypeTabs = () => {
  const { smellType } = useParams();
  const navigate = useNavigate();
  const selected = smellType || "all";

  return (
    <div className="d-flex flex-wrap gap-2">
      {["All", "Architecture", "Implementation", "Design", "Testability", "Test"].map((type) => {
        const route = type.toLowerCase();
        return (
          <button
            key={type}
            className={`btn btn-lg smell-type ${selected === route ? "active" : ""}`}
            onClick={() => navigate(`/visualize/${route}`)}
          >
            {type === "All" ? "Summary" : `${type} smells`}
          </button>
        );
      })}
    </div>
  );
};

export default SmellTypeTabs;
